import type { Session } from '@acepoker/contract'
import { api } from './api'
import { ApiVerifyCodeQuerySchema } from '@acepoker/contract/api'

export const verifyCode = async (
  email: string,
  code: string
): Promise<{ token: Session['token'] }> => {
  ApiVerifyCodeQuerySchema.parse({ email, code })

  const searchParams = new URLSearchParams()
  searchParams.append('email', email)
  searchParams.append('code', code)

  const endpoint = `/api/auth/verify-code?${searchParams.toString()}`
  return await api().url(endpoint).post({}).json()
}
